import React from 'react';

export const Hero: React.FC = () => {
    return (
        <div className="text-center mb-2 animate-in slide-in-from-bottom-5 duration-700">
            <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-4 leading-tight">
                Economize em <br />
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400 animate-gradient">
                    cada clique
                </span>
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-400 max-w-lg mx-auto leading-relaxed">
                Ofertas reais, cupons atualizados e links otimizados.
                <br />
                Tudo pra você pagar menos, sem complicação.
            </p>
        </div>
    );
};
